import React from 'react';
import {connect} from 'react-redux';
import {reduxForm} from 'redux-form';
import {defineMessages, FormattedMessage, FormattedHTMLMessage} from 'react-intl';

import FormField from './../FormField.jsx';
import FormDateField from './../FormDateField.jsx';
import FormPhoneField from './../FormPhoneField.jsx';
import FormSelectableField from './../FormSelectableField.jsx';
import FormCountrySelectField from './../FormCountrySelectField.jsx';
import RegistrationFormValidation from './RegistrationFormValidation';
import { isRingo } from '../../../../shared/domainUtils.js';

const messages = defineMessages({
    title: {
        id: 'join.title',
        defaultMessage: 'Регистрация'
    },
    login: {
        id: 'join.login',
        defaultMessage: 'Логин'
    },
    password: {
        id: 'join.password',
        defaultMessage: 'Пароль'
    },
    passwordRepeat: {
        id: 'join.password_repeat',
        defaultMessage: 'Повторите пароль'
    },
    firstName: {
        id: 'join.first_name',
        defaultMessage: 'Имя'
    },
    lastName: {
        id: 'join.last_name',
        defaultMessage: 'Фамилия'
    },
    dob: {
        id: 'join.dob',
        defaultMessage: 'Дата рождения'
    },
    email: {
        id: 'join.email',
        defaultMessage: 'E-mail'
    },
    phone: {
        id: 'join.phone',
        defaultMessage: 'Мобильный телефон'
    },
    city: {
        id: 'join.city',
        defaultMessage: 'Город'
    },
    promo: {
        id: 'join.promo',
        defaultMessage: 'Промо-код'
    },
    country: {
        id: 'join.country',
        defaultMessage: 'Страна'
    },
    currency: {
        id: 'join.currency',
        defaultMessage: 'Валюта счета'
    },
    language: {
        id: 'join.language',
        defaultMessage: 'Язык'
    },
    timezone: {
        id: 'join.timezone',
        defaultMessage: 'Часовой пояс'
    },
    buttonJoin: {
        id: 'join.button_join',
        defaultMessage: 'Зарегистрироваться'
    },
    tacAgree: {
        id: 'join.fast.tac_agree',
        defaultMessage: "Нажимая кнопку, вы соглашаетесь с <a href={rulesLink} target='_blank'>правилами компании</a>, <a href={privacyLink} target='_blank'>политикой конфиденциальности</a>, и подтверждаете свое совершеннолетие"
    },
    tacAgreeRingo: {
        id: 'join.fast.tac_agree_ringo',
        defaultMessage: "Нажимая кнопку, вы соглашаетесь с <a href={rulesLink} target='_blank'>правилами компании</a>, <a href={privacyLink} target='_blank'>политикой конфиденциальности</a>, и подтверждаете, что Ваш возраст превышает 21 год"
    },
    realInfoWarning: {
        id: 'join.real_info_warning',
        defaultMessage: 'Внимание! Вводите реальные данные, при снятии средств со счета они будут сверяться с ' +
        'документом удостоверяющим Вашу личность (паспорт, водительское удостоверение). ' +
        'Редактирование имени и фамилии после регистрации невозможно.'
    },
    internalErrorText: {
        id: 'join.errors.internal',
        defaultMessage: 'Ошибка'
    },
    loginTakenErrorText: {
        id: 'join.errors.login_taken',
        defaultMessage: 'Логин используется'
    },
    emailTakenErrorText: {
        id: 'join.errors.email_taken',
        defaultMessage: 'E-mail используется'
    },
    phoneTakenErrorText: {
        id: 'join.errors.phone_taken',
        defaultMessage: 'Телефон используется'
    },
    invalidPromo: {
        id: 'join.errors.invalid_promo',
        defaultMessage: 'Неверный промо-код'
    },
    timezone_1: {
        id: 'timezones.item_1',
        defaultMessage: 'Азия/Астана'
    },
    timezone_2: {
        id: 'timezones.item_2',
        defaultMessage: 'Европа/Москва'
    },
    promocodeTitle: {
        id: 'promocode.title',
        defaultMessage: 'Промо-код'
    },
    promocodePlaceholder: {
        id: 'promocode.enter',
        defaultMessage: 'Введите промо-код'
    },
    '-1':{
      id: "promocode.error.not_found",
      defaultMessage: "Ошибка. Попробуйте позже"
    },
    '-2':{
      id: "promocode.error.not_active",
      defaultMessage: "Промокод уже использован"
    },
    '-3':{
      id: "promocode.error.used",
      defaultMessage: "Промокод не действителен"
    },
    '-4':{
      id: "promocode.error.not_available",
      defaultMessage: "Промокод не действителен"
    },
});

const fields = [
    'login',
    'password',
    'passwordRepeat',
    'firstName',
    'lastName',
    'dob',
    'email',
    'phone',
    'countryId',
    'countryCode',
    'countryNumberLength',
    'city',
    'accountResourceId',
    'timezoneId',
    'promo',
    'PromocodeText'
];

const countriesJsonToOptions = (jsonSource) => {
    const optionsArr = [];
    for (let itemKey in jsonSource) {
        if (!jsonSource.hasOwnProperty(itemKey)) {
            continue;
        }

        const country = jsonSource[itemKey];
        const countryStr = `${country.name}`;
        const option = (<option key={itemKey} value={itemKey}>{countryStr}</option>);

        optionsArr.push(option);
    }

    return optionsArr;
};

const jsonSourceToOptions = (jsonSource) => {
    const optionsArr = [];
    for (let itemKey in jsonSource) {
        if (!jsonSource.hasOwnProperty(itemKey)) {
            continue;
        }

        let option;

        if (jsonSource[itemKey].hasOwnProperty('id') && jsonSource[itemKey].hasOwnProperty('defaultMessage')) {
            option = (
                <FormattedMessage key={itemKey} {...jsonSource[itemKey]}>
                    {(msg) => <option key={itemKey} value={itemKey}>{msg}</option>}
                </FormattedMessage>
            );
        } else {
            option = (<option key={itemKey} value={itemKey}>{jsonSource[itemKey]}</option>);
        }

        optionsArr.push(option);
    }

    return optionsArr;
};

const asyncValidate = (values) => {
    return new Promise((resolve, reject) => {
        let phone = values.countryCode.substring(1).concat(values.phone);
        if (/^\d+$/.test(values.phone) === false) {
            phone = undefined;
        }

        fetch(`/api/gambler/credentialsAvailable?login=${values.login}&email=${values.email}&phone=${phone}`, {
            credentials: 'include'
        })
            .then(response => response.json(), () => {
                reject({
                    login: messages.internalErrorText,
                    email: messages.internalErrorText,
                    phone: messages.internalErrorText
                });
            })
            .then(data => {
                if (data && data.login && data.email && data.phone &&
                    data.login.available !== undefined && data.email.available !== undefined &&
                    data.phone.available !== undefined) {
                    const loginAvailable = data.login.available;
                    const emailAvailable = data.email.available;
                    const phoneAvailable = data.phone.available;

                    if (loginAvailable === true && emailAvailable === true && phoneAvailable === true) {
                        resolve();
                    }

                    let response;
                    if (loginAvailable === false) {
                        response = {
                            login: messages.loginTakenErrorText
                        };
                    }
                    if (emailAvailable === false) {
                        response = Object.assign({}, response, {
                            email: messages.emailTakenErrorText
                        });
                    }
                    if (phoneAvailable === false) {
                        response = Object.assign({}, response, {
                            phone: messages.phoneTakenErrorText
                        });
                    }

                    reject(response);
                } else {
                    reject({
                        login: messages.internalErrorText,
                        email: messages.internalErrorText,
                        phone: messages.internalErrorText
                    });
                }
            });
    });
};

class RegistrationForm extends React.Component {
    static propTypes = {
        fields: React.PropTypes.object.isRequired,
        handleSubmit: React.PropTypes.func.isRequired,
        asyncValidating: React.PropTypes.any.isRequired,
        submitting: React.PropTypes.bool.isRequired,
        languageId: React.PropTypes.number.isRequired,
        joining: React.PropTypes.bool.isRequired,
        joinError: React.PropTypes.any,
        promoCodeError: React.PropTypes.any,
        accountResources: React.PropTypes.object.isRequired,
        countries: React.PropTypes.object.isRequired,
        languages: React.PropTypes.object.isRequired,
        timezones: React.PropTypes.object.isRequired,
        domain: React.PropTypes.string.isRequired,
        submitAction: React.PropTypes.func.isRequired,
        cancelCallback: React.PropTypes.func.isRequired
    };

    static renderError(error) {
        return (
            <div className="error-message">
                <FormattedMessage {...error}/>
            </div>
        );
    }

    static renderHint(hint) {
        return (
            <div className="hint hint--error">
                <FormattedMessage {...hint}/>
            </div>
        );
    }

    _onSubmit = (values) => {
        const phone = /^\d+$/.test(values.phone) === false ?
            undefined :
            values.countryCode.substring(1).concat(values.phone);

        this.props.submitAction({
            Login: values.login,
            Password: values.password,
            FirstName: values.firstName,
            LastName: values.lastName,
            Birthdate: values.dob,
            Email: values.email,
            Phone: phone,
            CountryId: values.countryId,
            City: values.city,
            AccountResourceId: values.accountResourceId,
            TimeZone: this.props.timezones[values.timezoneId],
            languageId: this.props.languageId,
            Promo: values.promo,
            PromocodeText: values.PromocodeText
        });
    }

    render() {
        const {
            fields:
                {login, password, passwordRepeat, firstName, lastName, dob, email, phone, countryId, PromocodeText,
                 countryCode, countryNumberLength, city, accountResourceId},
            asyncValidating, handleSubmit, submitting,
            joinError, promoCodeError, joining,
            accountResources, countries, domain
            } = this.props;

        const accountResourceOptions = jsonSourceToOptions(accountResources);
        const countriesOptions = countriesJsonToOptions(countries);

        const layerClass = 'login--form__row form__row';
        const warningClass = 'login--form__row form__row form__row--warning';
        const btnClass = 'login--form__btn login--form__btn__js form__btn';

        const btnDisabled = (asyncValidating || submitting || joining) ? 'disabled' : '';

        let errMessage = messages.internalErrorText;
        if (joinError === -15) {
            errMessage = messages.invalidPromo;
        }
        if(joinError === -5 && promoCodeError){
            errMessage = messages[promoCodeError];
        }

        const agreeOptions = {rulesLink: '//help.' + domain, privacyLink: '//help.' + domain + '/privacy'};

        return (<form className="login--form form" onSubmit={handleSubmit(this._onSubmit)} autoComplete="off">
                <input style={{display: "none"}} type="text" name="fakeusernameremembered"/>
                <input style={{display: "none"}} type="password" name="fakepasswordremembered"/>

                {joinError && RegistrationForm.renderError(errMessage)}

                <FormField message={messages.login} type="text" field={login} required/>

                <FormField message={messages.password} type="password" field={password} required/>

                <FormField message={messages.passwordRepeat} type="password" field={passwordRepeat}
                           required/>

                <div className={warningClass}>
                    <FormattedMessage {...messages.realInfoWarning}/>
                </div>

                <FormField message={messages.firstName} type="text" field={firstName} required/>

                <FormField message={messages.lastName} type="text" field={lastName} required/>

                <FormDateField message={messages.dob} field={dob} required/>

                <FormField message={messages.email} type="email" field={email} required/>

                <FormPhoneField message={messages.phone} type="text" field={phone}
                                countryCode={countryCode} numberLength={countryNumberLength}/>

                <FormCountrySelectField
                    disabled
                    message={messages.country}
                    field={countryId}
                    countryCodeField={countryCode}
                    countryNumberLengthField={countryNumberLength}
                    countries={countries}
                    options={countriesOptions}
                    required/>

                <FormField message={messages.city} type="text" field={city}/>

                <FormSelectableField
                    disabled
                    message={messages.currency}
                    field={accountResourceId}
                    options={accountResourceOptions}
                    required/>
                
                <FormField message={messages.promocodeTitle} type="text" field={PromocodeText}/>

                {/* <FormSelectableField
                    message={messages.timezone}
                    field={timezoneId}
                    options={timezonesOptions}
                    required/> */}

                <div className="form__row form__row--terms">
                    <FormattedHTMLMessage {...(isRingo ? messages.tacAgreeRingo : messages.tacAgree)} values={agreeOptions}/>
                </div>

                <div className="modal--content__controls">
                    <div className={layerClass}>
                        <button type="submit"
                                disabled={btnDisabled}
                                className={btnClass}
                                onClick={handleSubmit(this._onSubmit)}>
                            <FormattedMessage {...messages.buttonJoin}/>
                        </button>
                    </div>
                </div>
            </form>);
    }
}

export default connect()(reduxForm({
    form: 'registration-form',
    fields,
    asyncValidate,
    asyncBlurFields: ['login', 'email', 'phone', 'countryId', 'PromocodeText'],
    validate: RegistrationFormValidation
})(RegistrationForm));



// WEBPACK FOOTER //
// ./js/sport-betting/components/registration/regular/RegistrationForm.jsx